import React from "react";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";
import { Progress } from "antd";
import {
  isActiveReview,
  isCancelledReview
} from "../../pages/applications/applicationDetail/tabs/static/reviewHistory/model";

export const StatusComponent = ({ status, completedTasks, totalTasks }) => {
  const progress = Math.round((completedTasks / totalTasks) * 100);
  if (isActiveReview(status)) {
    return (
      <div>
        <ExclamationCircleFilled style={{ color: "#619faa", width: 18, height: 18 }}/>
        &nbsp;{status}
        <div style={{ marginLeft: "20px" }}>
          <Progress
            percent={progress}
            showInfo={true}
          />
          <div style={{ marginTop: "4px" }}>{`${completedTasks} of ${totalTasks}`}</div>
        </div>
      </div>
    );
  } else if (isCancelledReview(status)) {
    return (
      <div>
        <CloseCircleFilled style={{ color: "#e19e23", width: 18, height: 18 }}/>
        &nbsp;{status}
        <div style={{ marginLeft: "20px", marginTop: "4px" }}>
          {`${completedTasks} of ${totalTasks}`}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <CheckCircleFilled style={{ color: "#619faa", width: 18, height: 18 }}/>
        &nbsp;{status}
        <div style={{ marginLeft: "20px", marginTop: "4px" }}>
          {`${completedTasks} of ${totalTasks}`}
        </div>
      </div>
    );
  }
};
